import React from 'react';
import PropTypes from 'prop-types';

import { Container, Form, Button, Message} from 'semantic-ui-react';

const ChangeEmail = props => {
    let errorMessage;
    if (props.error) {
        const content = Array.isArray(props.error) ? props.error.map((e, index) => (<div key={index}>{`${e}`}</div>)) : props.error;
        errorMessage = (<Message error header="Email Change Failed" content={content} />);
    }
    const {username, confirmUsername, oldUsername} = props.data;
    const emailsMatch = username && confirmUsername && username === confirmUsername;
    return (
        <Container>
            <Form onSubmit={props.onSubmit} loading={props.loading} error>
                <Form.Field>
                    <input name="oldUsername" placeholder="Current Email" onChange={props.onChange} value={oldUsername || ''} type="email" />
                </Form.Field>
                <Form.Field>
                    <input name="username"  placeholder="New Email" onChange={props.onChange} value={username || ''} type="email" />
                </Form.Field>
                <Form.Field>
                    <input name="confirmUsername" placeholder="Confirm New Email" onChange={props.onChange} value={confirmUsername || ''} type="email" />
                </Form.Field>
                {errorMessage}
                <Button primary type="submit" disabled={!emailsMatch}>Change Email</Button>
            </Form>
        </Container>
    );
};

ChangeEmail.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.object.isRequired,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ])
};

export default ChangeEmail;